/* Heimzeit – behaviour for extra sections & product blocks */
(function () {
  const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

  /* ---------- Slider ---------- */
  if (!customElements.get('hz-slider')) {
    class HzSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.hz-slider__track');
        if (!this.track) return;
        this.slides = Array.from(this.track.children);
        this.prevBtns = this.querySelectorAll('.hz-slider__arrow--prev');
        this.nextBtns = this.querySelectorAll('.hz-slider__arrow--next');
        this.dotsWrap = this.querySelector('.hz-slider__dots');
        this.loop = this.dataset.loop === 'true';
        this.prevBtns.forEach((b) => b.addEventListener('click', () => this.go(-1)));
        this.nextBtns.forEach((b) => b.addEventListener('click', () => this.go(1)));
        this.track.addEventListener('scroll', () => this.update(), { passive: true });
        window.addEventListener('resize', () => this.build());
        this.build();
        const speed = parseFloat(this.dataset.autoplay || '0');
        if (speed > 0) {
          this.timer = setInterval(() => { if (this.active() && !this.hovered) this.go(1, true); }, speed * 1000);
          this.addEventListener('mouseenter', () => (this.hovered = true));
          this.addEventListener('mouseleave', () => (this.hovered = false));
          this.addEventListener('touchstart', () => (this.hovered = true), { passive: true });
        }
      }
      disconnectedCallback() { clearInterval(this.timer); }
      active() { return isMobile() ? this.hasAttribute('data-slider-mobile') : this.hasAttribute('data-slider-desktop'); }
      perView() {
        const s = this.slides[0];
        if (!s || !s.offsetWidth) return 1;
        return Math.max(1, Math.round(this.track.clientWidth / s.offsetWidth));
      }
      pages() { return Math.max(1, this.slides.length - this.perView() + 1); }
      index() {
        const s = this.slides[0];
        if (!s) return 0;
        const step = this.slides[1] ? this.slides[1].offsetLeft - s.offsetLeft : s.offsetWidth;
        return Math.round(this.track.scrollLeft / (step || 1));
      }
      build() {
        if (!this.dotsWrap) return this.update();
        const n = this.active() ? this.pages() : 0;
        if (this.dotsWrap.children.length !== n) {
          this.dotsWrap.innerHTML = '';
          for (let i = 0; i < n; i++) {
            const d = document.createElement('button');
            d.type = 'button';
            d.className = 'hz-slider__dot';
            d.setAttribute('aria-label', `${i + 1} / ${n}`);
            d.addEventListener('click', () => this.scrollToIndex(i));
            this.dotsWrap.appendChild(d);
          }
        }
        this.update();
      }
      scrollToIndex(i) {
        const target = this.slides[Math.max(0, Math.min(i, this.slides.length - 1))];
        if (target) this.track.scrollTo({ left: target.offsetLeft - this.slides[0].offsetLeft, behavior: 'smooth' });
      }
      go(dir, auto) {
        let i = this.index() + dir;
        const last = this.pages() - 1;
        if (i > last) i = this.loop || auto ? 0 : last;
        if (i < 0) i = this.loop ? last : 0;
        this.scrollToIndex(i);
      }
      update() {
        const i = this.index();
        const last = this.pages() - 1;
        if (this.dotsWrap) Array.from(this.dotsWrap.children).forEach((d, k) => d.setAttribute('aria-current', k === i ? 'true' : 'false'));
        if (!this.loop) {
          this.prevBtns.forEach((b) => (b.disabled = i <= 0));
          this.nextBtns.forEach((b) => (b.disabled = i >= last));
        }
      }
    }
    customElements.define('hz-slider', HzSlider);
  }

  /* ---------- Before / after ---------- */
  if (!customElements.get('hz-compare')) {
    class HzCompare extends HTMLElement {
      connectedCallback() {
        const range = this.querySelector('.hz-compare__range');
        if (!range) return;
        const set = () => this.style.setProperty('--hz-pos', range.value + '%');
        range.addEventListener('input', set);
        set();
      }
    }
    customElements.define('hz-compare', HzCompare);
  }

  /* ---------- Tabs ---------- */
  if (!customElements.get('hz-tabs')) {
    class HzTabs extends HTMLElement {
      connectedCallback() {
        this.btns = Array.from(this.querySelectorAll('.hz-tabs__btn'));
        this.panels = Array.from(this.querySelectorAll('.hz-tabs__panel'));
        this.btns.forEach((b, i) => b.addEventListener('click', () => this.select(i)));
      }
      select(i) {
        this.btns.forEach((b, k) => b.setAttribute('aria-selected', k === i ? 'true' : 'false'));
        this.panels.forEach((p, k) => (p.hidden = k !== i));
        this.panels[i] && this.panels[i].querySelectorAll('video[autoplay]').forEach((v) => v.play && v.play().catch(() => {}));
      }
    }
    customElements.define('hz-tabs', HzTabs);
  }

  /* ---------- Hero slideshow ---------- */
  if (!customElements.get('hz-hero')) {
    class HzHero extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.hz-hero__slide'));
        this.dots = Array.from(this.querySelectorAll('.hz-hero__dot'));
        this.i = 0;
        this.dots.forEach((d, k) => d.addEventListener('click', () => this.show(k)));
        const speed = parseFloat(this.dataset.autoplay || '0');
        if (speed > 0 && this.slides.length > 1) this.timer = setInterval(() => this.show((this.i + 1) % this.slides.length), speed * 1000);
        let x0 = null;
        this.addEventListener('touchstart', (e) => (x0 = e.touches[0].clientX), { passive: true });
        this.addEventListener('touchend', (e) => {
          if (x0 === null || this.slides.length < 2) return;
          const dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) this.show((this.i + (dx < 0 ? 1 : -1) + this.slides.length) % this.slides.length);
          x0 = null;
        });
      }
      disconnectedCallback() { clearInterval(this.timer); }
      show(k) {
        this.i = k;
        this.slides.forEach((s, n) => s.classList.toggle('is-active', n === k));
        this.dots.forEach((d, n) => d.setAttribute('aria-current', n === k ? 'true' : 'false'));
      }
    }
    customElements.define('hz-hero', HzHero);
  }

  /* ---------- Sticky add to cart ---------- */
  if (!customElements.get('hz-sticky-atc')) {
    class HzStickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.mode = this.dataset.display || 'always';
        this.btn = this.querySelector('.hz-sticky__btn');
        this.select = this.querySelector('.hz-sticky__select');
        if (this.btn) this.btn.addEventListener('click', (e) => this.onClick(e));
        if (this.select) this.select.addEventListener('change', () => this.applyVariant(this.select.value));
        this.onScroll = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsub = subscribe(PUB_SUB_EVENTS.variantChange, (event) => this.onVariant(event));
        }
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        if (this.unsub) this.unsub();
      }
      mainButton() { return document.getElementById(`ProductSubmitButton-${this.sectionId}`); }
      onScroll() {
        if (this.mode === 'always') return this.classList.add('is-visible');
        const btn = this.mainButton();
        if (!btn) return this.classList.add('is-visible');
        const r = btn.getBoundingClientRect();
        this.classList.toggle('is-visible', r.bottom < 0);
      }
      onClick(e) {
        const target = this.dataset.function || 'add_to_cart';
        if (target.indexOf('scroll_') === 0) {
          e.preventDefault();
          const sel = target.replace('scroll_', '');
          const el = document.querySelector(sel) || document.getElementById(`variant-selects-${this.sectionId}`);
          if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        const btn = this.mainButton();
        if (btn) { e.preventDefault(); btn.click(); }
      }
      applyVariant(variantId) {
        const data = this.querySelector('script[data-hz-variants]');
        if (!data) return;
        const variants = JSON.parse(data.textContent);
        const v = variants.find((x) => String(x.id) === String(variantId));
        const picker = document.getElementById(`variant-selects-${this.sectionId}`);
        if (!v || !picker) return;
        v.options.forEach((value, idx) => {
          const selects = picker.querySelectorAll('select');
          const fieldsets = picker.querySelectorAll('fieldset');
          let changed = false;
          const sel = selects[idx];
          if (sel) {
            const opt = Array.from(sel.options).find((o) => o.value === value || o.textContent.trim() === value);
            if (opt && sel.value !== opt.value) {
              sel.value = opt.value;
              sel.dispatchEvent(new Event('change', { bubbles: true }));
              changed = true;
            }
          }
          if (!changed && fieldsets[idx]) {
            const input = Array.from(fieldsets[idx].querySelectorAll('input[type="radio"]')).find((i) => i.value === value);
            if (input && !input.checked) {
              input.checked = true;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        });
      }
      onVariant(event) {
        const d = event && event.data;
        if (!d || d.sectionId !== this.sectionId || !d.html) return;
        const fresh = d.html.getElementById ? d.html.getElementById(this.id) : null;
        if (fresh) {
          const inner = this.querySelector('.hz-sticky__inner');
          const newInner = fresh.querySelector('.hz-sticky__inner');
          if (inner && newInner) {
            inner.replaceWith(newInner);
            this.btn = this.querySelector('.hz-sticky__btn');
            this.select = this.querySelector('.hz-sticky__select');
            if (this.btn) this.btn.addEventListener('click', (e) => this.onClick(e));
            if (this.select) this.select.addEventListener('change', () => this.applyVariant(this.select.value));
          }
        }
      }
    }
    customElements.define('hz-sticky-atc', HzStickyAtc);
  }
})();
